import { Koi } from '@ksyos/koi';

export const adminProcessesListFilterSchemaArgs = {
    endDate: Koi.when('startDate', {
        is: Koi.exist(),
        otherwise: Koi.koi().date(),
        then: Koi.koi().date().endDate(),
    }).allow(null),
    startDate: Koi.koi().date().allow(null),
    text: Koi.string().max(255).allow(''),
};

export const adminProcessesFilterInputFieldSchema = {
    schema: Koi.object(adminProcessesListFilterSchemaArgs),
};
